import { useState } from 'react'

import {
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Row,
  Copy
} from 'components'
import {
  DownloadIcon,
  ViewFileIcon,
  CancelIcon,
  MagnifyingGlassIcon
} from 'components/Icons'
import { Link } from 'components/Link/Link'
import { useModal } from 'hooks'
// import { openBase64InNewWindow, downloadBase64 } from "utils/functions"
import { useLoading, useFile, useToggle } from 'hooks'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { IChecklistFilterResponse } from 'services/NGT/PendingAnalysis'
import { DocumentServices } from 'services/Supplier/Ged'
import { SPACING, COLORS } from 'utils'
import { HandleCompetencia } from 'utils/functions'

import { ViewContractModal } from '../../../ViewContractModal/ViewContractModal'

interface ITableChecklistPending {
  tableData: IChecklistFilterResponse[]
  rowsPerPage: number
  page: number
  totalItems: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  setRowsPerPage: React.Dispatch<React.SetStateAction<number>>
  setChangeEffect: React.Dispatch<React.SetStateAction<boolean>>
  handleBlockItem: (_idMovDocumentoItem: number) => void
  areDatesValid: boolean
}

export const TableChecklistPending = ({
  tableData,
  totalItems,
  page,
  rowsPerPage,
  setRowsPerPage,
  areDatesValid,
  setPage,
  handleBlockItem
}: ITableChecklistPending) => {
  const { viewFile, downloadFile } = useFile()
  const { showModal } = useModal()
  const [selectedContractId, setSelectedContractId] = useState(0)
  const { setLoading } = useLoading()
  const history = useHistory()
  const [openViewContractModal, toggleViewContractModal] = useToggle()

  const handleViewContractModal = (contractId: number) => {
    setSelectedContractId(contractId)
    toggleViewContractModal()
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value))
    setPage(1)
  }

  const handleChangePage = (newPage: number) => {
    setPage(newPage)
  }

  const handleBuscarDocumento = (cdDocumento, tipo) => {
    setLoading('loading')

    DocumentServices()
      .SearchDocumentv3(cdDocumento)
      .then((response) => {
        if (response.status === 200) {
          if (tipo === 'visualizar') {
            viewFile({
              gedExternalID:cdDocumento
            })
          } else {
            downloadFile({
              gedExternalID:cdDocumento
            })
          }
        }

        setLoading('idle')
      })
      .catch(() => {
        showModal({
          hideButtonCancel: true,
          message: 'Infelizmente não foi possível encontrar o documento',
          type: 'error'
        })

        setLoading('idle')
      })
  }

  const formatDate = (date: string | Date) => {
    return moment(date).format('YYYY') === '0001'
      ? '- - - - - -'
      : moment(date).format('DD/MM/YYYY')
  }

  const handleClickContract = (obj) => {
    // # TODO ANALISE CRE
    history.push({
      pathname: '/ngt/analise-cre',
      state: {
        cdContrato: obj.cdContrato,
        dtCompetencia: obj.competencia,
        idCreExist: obj.creId,
        isConsult: true,
        pathBack: '/ngt/analise-pendencia-cre',
        tab: 2
      }
    })
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left"></TableCellStyled>
              <TableCellStyled align="left">Contrato</TableCellStyled>
              <TableCellStyled minwidth="10em" align="left">
                Fornecedor
              </TableCellStyled>
              <TableCellStyled align="left">Tipo Documento</TableCellStyled>
              <TableCellStyled align="left">Competência</TableCellStyled>
              <TableCellStyled align="left">Data Anexada</TableCellStyled>
              <TableCellStyled align="left">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData &&
              tableData.map((row) => (
                <TableRowStyled>
                  <TableCellStyled align="left">
                    <Copy
                      title="Copiar código de contrato"
                      valueToCopy={row.cdContrato}
                    />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    <Link
                      color={COLORS.blueFonts}
                      onClick={() => handleViewContractModal(row.idContrato)}
                    >
                      {row.cdContrato}
                    </Link>
                  </TableCellStyled>
                  <TableCellStyled minwidth="10em">
                    {row.nmFornecedor}
                  </TableCellStyled>
                  <TableCellStyled>{row.dsTipoPendencia}</TableCellStyled>
                  <TableCellStyled align="left">
                    {HandleCompetencia(row.competencia)}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {formatDate(row.dtAnexado) != 'Data inválida'
                      ? formatDate(row.dtAnexado)
                      : '- - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <Row justifyContent="center" alignItems="center">
                      <MagnifyingGlassIcon
                        onClick={() => handleClickContract(row)}
                        marginRight={SPACING.spacing15}
                        cursor="pointer"
                      />
                      <ViewFileIcon
                        onClick={() =>
                          row.comDocumento
                            ? handleBuscarDocumento(
                                row.cdDocumento,
                                'visualizar'
                              )
                            : null
                        }
                        marginRight={SPACING.spacing15}
                        disabled={!row.comDocumento}
                        cursor="pointer"
                      />
                      <DownloadIcon
                        onClick={() =>
                          row.comDocumento
                            ? handleBuscarDocumento(row.cdDocumento, 'download')
                            : null
                        }
                        marginRight={SPACING.spacing15}
                        disabled={!row.comDocumento}
                        cursor="pointer"
                      />
                      <CancelIcon
                        colorIcon={
                          row.comDocumento ? COLORS.error : COLORS.gray
                        }
                        cursor="pointer"
                        disabled={!row.comDocumento}
                        onClick={() => {
                          showModal({
                            handleConfirm: () => {
                              handleBlockItem(row.idMovDocumentoItem)
                            },
                            message:
                              'Tem certeza que deseja recusar o documento?',
                            type: 'alert'
                          })
                        }}
                      />
                    </Row>
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        totalItems={totalItems}
        disabled={!areDatesValid}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
      <ViewContractModal
        showModal={openViewContractModal}
        toggleModal={toggleViewContractModal}
        contractID={selectedContractId}
      />
    </>
  )
}
